// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see InvestingSponsoredAccountTeenRequestAuthorizationStartRequestEvent
 */
export var InvestingSponsoredAccountTeenRequestAuthorizationStartRequest = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "InvestingSponsoredAccount TeenRequestAuthorization StartRequest",
        parameters: {
            cdf_entity: "InvestingSponsoredAccount",
            cdf_action: "TeenRequestAuthorization",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InvestingSponsoredAccountSponsorRespondToAuthorizationRequestStartApprovalEvent
 */
export var InvestingSponsoredAccountSponsorRespondToAuthorizationRequestStartApproval = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "InvestingSponsoredAccount SponsorRespondToAuthorizationRequest StartApproval",
        parameters: {
            cdf_entity: "InvestingSponsoredAccount",
            cdf_action: "SponsorRespondToAuthorizationRequest",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InvestingSponsoredAccountSponsorRespondToAuthorizationRequestCompleteApprovalEvent
 */
export var InvestingSponsoredAccountSponsorRespondToAuthorizationRequestCompleteApproval = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "InvestingSponsoredAccount SponsorRespondToAuthorizationRequest CompleteApproval",
        parameters: {
            cdf_entity: "InvestingSponsoredAccount",
            cdf_action: "SponsorRespondToAuthorizationRequest",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InvestingSponsoredAccountSponsorRespondToAuthorizationRequestDeclineEvent
 */
export var InvestingSponsoredAccountSponsorRespondToAuthorizationRequestDecline = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "InvestingSponsoredAccount SponsorRespondToAuthorizationRequest Decline",
        parameters: {
            cdf_entity: "InvestingSponsoredAccount",
            cdf_action: "SponsorRespondToAuthorizationRequest",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
